export const getSize = value => typeof value === 'number' ? `${value}px` : value;